import { APP_NAME, AppConfigMap } from 'app-config'

export const getAppConfigMap = () => {
  return {
    appName: APP_NAME,
    appConfig: AppConfigMap[APP_NAME],
  }
}
